// @flow
import React, { type Node } from 'react';

type Props = {
  children?: Node,
  className?: string,
  disabled?: boolean,
  fieldValue?: mixed,
  id: string,
  input: Object,
  label?: string,
  type: 'checkbox' | 'radio',
};

// This is meant to be used as the component prop for a redux-form Field.
export default function CheckRadio({
  children,
  className,
  disabled,
  fieldValue,
  id,
  input,
  label,
  type,
}: Props) {
  const style =
    type === 'checkbox' ? { marginTop: '5px' } : { marginBottom: '5px' };
  const checked =
    type === 'checkbox' ? input.checked : input.value === fieldValue;
  className = className || '';
  return (
    <div className={className} style={style}>
      <input
        {...input}
        checked={checked}
        className={`is-checkradio ${className ? className : ''}`}
        disabled={disabled}
        id={id}
        type={type}
      />
      <label htmlFor={id}>{label}</label>
      {children}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/view/Forms/BulmaCheckRadio.js